import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const LaunchTeaser = lazy(
  () =>
    import(
      '@aboutyou/logic-components/src/client-services/LaunchTeaser/LaunchTeaser'
    ).then(mod => ({default: mod.LaunchTeaser})),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
